import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';

import { I18nTranslator } from '../../i18n/translate';
import { Campaign } from '../../models/campaign.model';
import { CampaignYearPipe } from '../../pipes/campaignYear.pipe';
import { CampaignService } from '../../services/campaign.service';
import { ExportsService } from '../../services/exports.service';
import { currentDateFormatted } from '../../utils/utils';
import { COMPANY_NAME, PRODUCT_NAME } from '../../utils/env';
import { ExportsComponent } from './exports';

import { saveAs } from 'file-saver';
import { TranslateWithPunctuationPipe, TranslatePipe } from '../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

export class ExportCommandsDialogContext {
  parent: ExportsComponent;
  slice: 'complete' | 'incomplete';
}

@Component({
  standalone: true,
  selector: 'export-commands-dlg',
  templateUrl: 'export-commands-dialog.component.html',
  providers: [CampaignService, ExportsService],
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, CampaignYearPipe, TranslateWithPunctuationPipe, TranslatePipe, FormsModule],
})
export class ExportCommandsDialogComponent implements OnInit {
  productName = PRODUCT_NAME;
  error: any;
  context: ExportCommandsDialogContext;
  campaigns: Campaign[];
  slice: 'complete' | 'incomplete';
  campaignExportId: number;
  filter: any;

  constructor(
    public dialog: DialogRef<ExportCommandsDialogContext>,
    private campaignService: CampaignService,
    private exportsService: ExportsService,
    private i18nTranslator: I18nTranslator,
    private router: Router,
  ) {
    this.context = dialog.context;
    this.slice = this.context.slice;
  }

  ngOnInit() {
    this.campaignService.getCampaigns().subscribe((x) => {
      this.handleCampaigns(x);
    });

    if (this.slice === 'incomplete') {
      this.filter = { has_t2: true, completed: false };
    } else {
      this.filter = { completed: true };
    }
  }

  handleCampaigns(campaigns: Campaign[]) {
    this.campaigns = campaigns.sort(Campaign.compare).reverse();

    if (this.campaigns.length > 0) {
      this.campaignExportId = this.campaigns[0].id;
    }
  }

  download() {
    this.exportsService.downloadCommands(this.campaignExportId, this.filter).subscribe(
      (res) => {
        const dateFormatted = currentDateFormatted('', false);
        const company_name = COMPANY_NAME.replace(/ /g, '_').toUpperCase();
        const fileNamePart = this.i18nTranslator.translate('exports.commandes.fileName.part');
        const fileName = fileNamePart + '_' + company_name + '_' + dateFormatted + '.xlsx';
        saveAs(res, fileName);

        this.dialog.close();
      },
      (error) => {
        this.dialog.close();

        const msg = this.i18nTranslator.translate('exports.error.telecharger');
        this.context.parent.handleError(error, msg);
      },
    );
  }

  dismiss() {
    this.dialog.close();
  }
}
